import React, { useReducer } from "react";
import reducers from "./reducers";
import { FORM_VALIDATIONS_ERRORS, GET_CUSTOMER_LIST_BEGIN, GET_CUSTOMER_LIST_ERROR, GET_CUSTOMER_LIST_SUCCESS, GET_DASHBOARD_SIDEBAR_LINKS_BEGIN, GET_DASHBOARD_SIDEBAR_LINKS_ERROR, GET_DASHBOARD_SIDEBAR_LINKS_SUCCESS, GET_FORM_VALUES, GET_INSURENCE_COMPANIES, GET_NOTES_BEGIN, GET_NOTES_ERROR, GET_NOTES_SUCCESS, GET_SELECTED_PATIENT, GET_VALUES_OF_REFFERED, GET_VALUES_OF_REFFERED_ADJUSTER_ID, OPEN_TAB, RESET_FORM_VALUES } from "./actions";
import axios from "axios";
import { baseUrl } from "../common/constants";
import _axios from "../utils/api/_axios";

const initialState = {
  categories: null,
  setCategories: () => { },
  activeTab: 0,
  customerList: [],
  isLoading: true,
  dashboardSidebarList: [],
  notes: [],
  new_notes: [],
  new_styles: [],
  formDataValues:{
    patientInfo:{},
    employeeInfo:{},
    referredByInfo:{
    },
    proceduresInfo:[{
      bodyParts:"",
      bodySide:"",
      procedure:"",
      diagnosisRuleOut1:"",
      diagnosisRuleOut2:""
    }],
    specialInstruction:{},
  },
  insuranceCompanies:[],
  insurenceName:"",
  insurenceId:"",
  adjustureType:"",
  adjusterId:"",
  isAdminAprovedIds:[],
  selectedPatient:{},
  errors:{}
};

export const mainContext = React.createContext();

const MainContextProvider = (props) => {
  const [state, dispatch] = useReducer(reducers, initialState)
  const currentTab = (active) => {
    dispatch({ type: OPEN_TAB, payload: active })
  }
  // const fetchCustomerList = async (category, limit, page) => {
  //   dispatch({ type: GET_CUSTOMER_LIST_BEGIN })
  //   try {
  //     const response = await _axios.get(`${baseUrl}/dashboard/claims/${category}?limit=${limit}&page=${page}`);
  //     const { data } = response
  //     if (data.metadata.status === true) {
  //       dispatch({ type: GET_CUSTOMER_LIST_SUCCESS, payload: data.payload })
  //     }
  //     else {
  //       dispatch({ type: GET_CUSTOMER_LIST_ERROR, payload: data })
  //     }
  //   } catch (error) {
  //     dispatch({ type: GET_CUSTOMER_LIST_ERROR, payload: error })
  //   }
  // }
  // TODO correct all the reducers
  const getCustomerList = async (adjusterId) => {
    dispatch({ type: GET_CUSTOMER_LIST_BEGIN })
    try {
      const response = await _axios.get(`${baseUrl}/dashboard/claims${adjusterId? `?adjusterId=${adjusterId}`: ""}`)
      const { data } = response
      if (data.metadata.status === true) {
        dispatch({ type: GET_CUSTOMER_LIST_SUCCESS, payload: data.payload })
      }
      else {
        dispatch({ type: GET_CUSTOMER_LIST_ERROR, payload: data })
      }
    } catch (error) {
      dispatch({ type: GET_CUSTOMER_LIST_ERROR, payload: error })
    }
  }
  const getDashboardSidebarLinks = async (category) => {
    dispatch({ type: GET_DASHBOARD_SIDEBAR_LINKS_BEGIN })
    try {
      const categoryLink = category ? `?category=${category}` : "";
      const response = await _axios.get(`${baseUrl}/dashboard/adjusters${categoryLink}`)
      const { data } = response;
      if (data.metadata.status === true) {
        dispatch({ type: GET_DASHBOARD_SIDEBAR_LINKS_SUCCESS, payload: data.payload })
      }
      else {
        dispatch({ type: GET_DASHBOARD_SIDEBAR_LINKS_ERROR, payload: data })
      }
    } catch (error) {
      dispatch({ type: GET_DASHBOARD_SIDEBAR_LINKS_ERROR, payload: error })
    }
  }

  const getNotesData = async (patientId, claimId) => {
    dispatch({type:GET_NOTES_BEGIN})
    try {
      const addClaim = claimId?`/claim/${claimId}`: `/patient/${patientId}`;
      const response = await _axios.get(`${baseUrl}/history${addClaim}`)
      const {data}= response;
      dispatch({type:GET_NOTES_SUCCESS, payload:data.payload})
    } catch (error) {
      dispatch({ type: GET_NOTES_ERROR, payload: error })
    }
  }

  const getFormData=(data)=>{
    dispatch({type:GET_FORM_VALUES, payload:data})
  }

  const resetFormData=(data)=>{
    dispatch({type:RESET_FORM_VALUES, payload:data})
  }


  const getValuesRefferedForm=(insurenceId)=>{
    dispatch({type:GET_VALUES_OF_REFFERED, payload:insurenceId})
  }

  const getValuesRefferedAdjusterId=(adjusterId)=>{
    dispatch({type:GET_VALUES_OF_REFFERED_ADJUSTER_ID, payload:adjusterId})
  }

  const setComapniesData=(companies)=>{
    dispatch({type:GET_INSURENCE_COMPANIES, payload:companies})
  }

  
  const setSelectedPatient=(patient)=>{
    dispatch({type:GET_SELECTED_PATIENT, payload:patient})
  }

  const setErrors=(errors)=>{
    dispatch({type:FORM_VALIDATIONS_ERRORS, payload:errors})
  }

  const values = {
    categories: state.categories,
    setCategories: state.setCategories,
    activeTab: state.activeTab,
    customerList: state.customerList,
    isLoading: state.isLoading,
    dashboardSidebarList: state.dashboardSidebarList,
    notes: state.notes,
    new_notes: state.new_notes,
    new_styles: state.new_styles,
    insuranceCompanies:state.insuranceCompanies,
    formDataValues:state.formDataValues,
    selectedPatient:state.selectedPatient,
    errors:state.errors,
    currentTab,
    getDashboardSidebarLinks,
    getCustomerList,
    // fetchCustomerList,
    getNotesData,
    getValuesRefferedForm,
    setComapniesData,
    getValuesRefferedAdjusterId,
    getFormData,
    setSelectedPatient,
    setErrors,
    resetFormData
  };

  return (

    <mainContext.Provider value={values}>
      {props.children}
    </mainContext.Provider>

  );

};

export default MainContextProvider;